import { ThemeProvider } from "@mui/material/styles";
import { RouterProvider } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";

import { theme } from "./src/muiTheme";
import { router } from "./src/router";
import "./src/styles/main.css";

const mountNode = document.getElementById("app");
// biome-ignore lint/style/noNonNullAssertion: mount node is always present in index.html
const root = createRoot(mountNode!);
root.render(
  <ThemeProvider theme={theme}>
    <RouterProvider router={router} />
  </ThemeProvider>,
);
